import React, { useEffect, useRef, useState } from "react";
import LazyLoad from "react-lazyload";
import DtvGrid from "@directv-digital/dds.ui.dtv-grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import DtvTheme, { colorPalette, DESKTOP_WIDTH, TABLET_WIDTH } from "@directv-digital/dds.ui.dtv-theme";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import CardMedia from "@mui/material/CardMedia";
import ChannelLogoChip from "@/shared/ChannelLogoChip";
import DtvText from "@directv-digital/dds.ui.dtv-text";
import Tooltip from "@mui/material/Tooltip";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";

let unqId = 0;
export function uniqId(prefix = "id") {
  // eslint-disable-next-line no-plusplus
  unqId++;
  return `${prefix}${unqId}`;
}

export interface NationalChnlTableProps {
  packages: any[];
  channels: any[];
  sortOptions: any[];
  channelCategories: any[];
  serviceLogoPath: string;
  isChannelLineUpPage?: boolean;
  serviceNameLabel: string;
  commonData: any;
  viewMode: any;
  activeTab: any;
  modalView: boolean;
  edspFlow?: boolean;
  packageCategorySelected?: string;
  packageBgColor?: any;
  customPackage: any[];
  expanded: boolean;
  cmprPkg?: string;
  modalSrc?: string;
  channelsQP?: string;
  pkgHeight?: number;
  lang?: string;
  // serviceId?: string;
  showCTA?: string;
  showCtaCI?: string;
  customPkgIndex?: any;
  changeViewModeFromNationalTable?: any;
  myFreeDTVChnls?: any;
}
export function NationalChnlTable(props: NationalChnlTableProps) {
  try {
    const [didScroll, setDidScroll] = useState(false);
    const [_commonDataValue] = useState<any>(props?.commonData);
    const [_windowOrigin, setWindowOrigin] = useState("");
    const [headerLeft, setHeaderLeft] = useState<number>();
    const [_headerWidth, setHeaderWidth] = useState<number>();
    const [position, setPosition] = useState("static");
    const isChannelLineUpPage = props?.isChannelLineUpPage || false;
    // NOTE: for edsp=false query parm = spanish
    // const [edspPackages, setEdspPackages] = useState(props?.packages && props?.packages.filter((p) => props?.edspFlow === p.edsp));
    const [maxWidth, setMaxWidth] = useState(
      // edspPackages.length > 1 ? 100 / (edspPackages.length + 1) : 100
      props?.packages.length > 1 ? 100 / (props?.packages.length + 1) : 100
    );

    const [tableHeaderTop, setTableHeaderTop] = useState(0);
    const [updatedChnlCategories, _setUpdatedChnlCategories] = useState([
      ...(props?.channelCategories ?? []),
      {
        key: "ADD_ON_CHANNELS",
        value: "Add on channels"
      }
    ]);
    const expandAccordionArray = updatedChnlCategories.map((_obj, index) => (index === 0 ? { expanded: true } : { expanded: false }));
    const [expandAccordion, setExpandAccordion] =
      useState(expandAccordionArray);
    const [chnlNameNumberCategories, _setChnlNameNumberCategories] = useState([
      {
        key: "INCLUDED_CHANNELS",
        value: "Included channels"
      },
      {
        key: "ADD_ON_CHANNELS",
        value: "Add on channels"
      }
    ]);
    const chnlNameNumberAccordionArray = chnlNameNumberCategories.map(
      (_obj, index) => (index === 0 ? { expanded: true } : { expanded: false })
    );
    const [chnlNameNumberAccordion, setChnlNameNumberAccordion] = useState(
      chnlNameNumberAccordionArray
    );
    const [_latestAccordionOpen, setLatestAccordionOpen] = useState([0]);
    const tableHeaderRef = useRef<any>();
    const modalSrc = props?.modalSrc && props?.modalSrc.toUpperCase();
    const displayCTA = !!modalSrc;
    const pkgHeight =  tableHeaderRef?.current?.getBoundingClientRect?.()?.height;
    const categoryChannels = props?.channels;
    const myFreeDtvChnls = props?.myFreeDTVChnls;
    // const classes = useStyles({ maxWidth, pkgHeight });

    const _UpIcon = (_props: any) => (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 25 25"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.84711 9.03841C3.84711 8.6233 3.99836 8.20139 4.30743 7.88155C4.92557 7.24868 5.92512 7.24868 6.53668 7.88155L12.1657 13.7203L17.8078 7.86794C18.4259 7.22827 19.4189 7.22827 20.037 7.86794C20.6552 8.50761 20.6552 9.53517 20.037 10.1748L13.7241 16.7213C13.3164 17.1432 12.7509 17.3882 12.1591 17.3882C11.5738 17.3882 11.0017 17.15 10.594 16.7281L4.29431 10.1953C3.98524 9.87542 3.83398 9.46031 3.83398 9.04521"
          fill="#102641"
        />
      </svg>
    );

    const _DownIcon = (_props: any) => (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 25 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.1529 15.0163C21.1529 15.4314 21.0016 15.8533 20.6926 16.1731C20.0744 16.806 19.0749 16.806 18.4633 16.1731L12.8343 10.3344L7.1922 16.1867C6.57406 16.8264 5.58109 16.8264 4.96295 16.1867C4.34482 15.5471 4.34482 14.5195 4.96295 13.8798L11.2759 7.3334C11.6836 6.91148 12.2491 6.66651 12.8409 6.66651C13.4262 6.66651 13.9983 6.90467 14.406 7.32658L20.7057 13.8594C21.0148 14.1793 21.166 14.5944 21.166 15.0095"
          fill="#102641"
        />
      </svg>
    );
    const [_detailsVisible, _setDetailsVisible] = useState(false);
    const [_selectedChannel, _setSelectedChannel] = useState(null);

    const tableRef = useRef();
    const [_tableWidth, setTableWidth] = React.useState(0);
    const [viewportWidth, setViewportWidth] = React.useState(DESKTOP_WIDTH)

    React.useEffect(() => {
      if (tableRef?.current?.offsetWidth) {
        setTableWidth(tableRef?.current?.offsetWidth);
      }
    }, [tableRef]);

    React.useEffect(() => {
      function handleResize() {
        if(typeof window !== "undefined"){
          setViewportWidth( screen?.width || window?.parent?.innerWidth || window?.innerWidth)
        }
      }

      handleResize();
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, [])

    const stickyHeaderCss = {
      backgroundColor: "#ffffff",
      // boxShadow: "grey 0px 0px 8px 0px",
      left: headerLeft,
      position,
      top: isChannelLineUpPage ? 0 : "48px", // 0
      width: "100%",
      zIndex: 999
    } as React.CSSProperties;

    useEffect(() => {
      setMaxWidth(
        // edspPackages.length > 1 ? 100 / (edspPackages.length + 1) : 100
        props?.packages.length > 1 ? 100 / (props?.packages.length + 1) : 100
      );
      // Update the document title using the browser API
      window.addEventListener("scroll", onScrollHandle);
      window.addEventListener("resize", onWindowResize);
      setWindowOrigin(window.location.origin);
      const header = document.getElementById("tableHeader");
      setHeaderLeft(header?.getBoundingClientRect().left);
      setHeaderWidth(header?.getBoundingClientRect().width);
      return () => window.removeEventListener("scroll", onScrollHandle);
    }, []);
    useEffect(() => {
      if (props?.expanded) {
        expandAccordion.forEach(item => {
          item.expanded = true;
        });
        setExpandAccordion([...expandAccordion]);
      } else if (!props?.expanded) {
        expandAccordion.forEach((item, index) => {
          item.expanded = !!(index === 0 || index === 1);
        });
        setExpandAccordion([...expandAccordion]);
      }
    }, [props?.expanded]);
    useEffect(() => {
      setPosition("static");
      setDidScroll(false);
      const header = document.getElementById("tableHeader");
      setTableHeaderTop(header?.offsetTop + 68);
    }, [props?.activeTab]);
    useEffect(() => {
      const chnlNameNumberAccordionArray = chnlNameNumberCategories.map(
        (_obj, index) => (index === 0 ? { expanded: true } : { expanded: false })
      );
      setChnlNameNumberAccordion(chnlNameNumberAccordionArray);
      if (props.viewMode === 1) {
        setLatestAccordionOpen([0]);
      } else if (props.viewMode === 2) {
        setLatestAccordionOpen([0, 1]);
      }
    }, [props?.viewMode]);
    const onWindowResize = () => {
      const header = document.getElementById("tableBody");
      if (header) {
        setHeaderLeft(header.getBoundingClientRect().left);
        setHeaderWidth(header.getBoundingClientRect().width);
      }
    };
    const onScrollHandle = () => {
      if (window.pageYOffset > tableHeaderTop) {
        setPosition("sticky");
        setDidScroll(true);
      } else {
        setPosition("static");
        setDidScroll(false);
      }
    };
    const _spanishCustomStyles =
      props?.lang?.toLowerCase() === "spanish" &&
      props?.channelsQP?.toLowerCase() === "satellite" ?
        0 :
        161;
    const styles = {
      tableBorder: {
        borderLeft: isChannelLineUpPage ? "none" : "1px solid transparent",
        borderRight: isChannelLineUpPage ? "none" : "1px solid transparent"
      },
      headBgColor: {
        backgroundColor: "#ffffff"
      },
      addOnStickyCss: {
        backgroundColor: isChannelLineUpPage ? "white.main" : "#21528C",
        boxShadow: "grey 0px 0px 8px 0px",
        position: "sticky",
        top: pkgHeight ? `${pkgHeight + 50}px` : "136px",
        zIndex: 998,

        [DtvTheme.breakpoints.between(
          DtvTheme.breakpoints.values.sm,
          DtvTheme.breakpoints.values.md
        )]: {
          top: pkgHeight ? `${pkgHeight +  50}px` : "254px" // 230 298
        },
        [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
          top: pkgHeight ? `${pkgHeight + 50}px` : "254px" // 236 304
        }
      },
      expandIconPosition: {
        "& .MuiAccordionSummary-expandIconWrapper": {
          alignSelf: "flex-start",
          margin: {
            md: "12px 0  !important",
            sm: "9px 0 !important",
            xs: "9px 0  !important"
          }
        }
      },
      addOnInfoStickyCss: {
        backgroundColor: isChannelLineUpPage ? "#FFFF" : "#21528C",
        boxShadow: "grey 0px 0px 8px 0px",
        position: "sticky",
        top: "178px",
        zIndex: 999,
        [DtvTheme.breakpoints.between(
          DtvTheme.breakpoints.values.sm,
          DtvTheme.breakpoints.values.md
        )]: {
          top: pkgHeight ? `${pkgHeight + 50}px` : "266px"
        },
        [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
          top: pkgHeight ? `${pkgHeight + 50}px` : "271px"
        }
      },
      showText: {
        display: "inline",
        position: "relative",
        bottom: "8px",
        fontSize: "14px !important",
        color: "#102641"
      },
      showContentSection: {
        width: "100%"
      },
      channelContent: {},
      teamsContainer: {
        display: "flex",
        background: "#555555",
        textAlign: "left",
        color: "#FDF7F7",
        height: "26px",
        alignItems: "center"
      },
      teamsTitle: {
        background: "black",
        textAlign: "left"
      },
      teamsContent: {
        textAlign: "left"
      },
      channelName: {
        fontSize: "14px",
        fontWeight: 500,
        color: isChannelLineUpPage ? "white.main" : "#666666"
      },
      bgColorForChnlsLabel: {
        backgroundColor: "#F4F4F4"
      },
      icons12: {
        height: "30px",
        width: "30px",
        verticalAlign: "middle",
        display: "inline-flex",
        objectFit: "contain"
      },
      legendIcons: {
        height: "24px",
        width: "24px",
        verticalAlign: "middle",
        display: "inline-flex"
      },
      accordianSummary: {
        "& .MuiAccordionSummary-content": {
          margin: {
            md: "12px 0  !important",
            sm: "9px 0 !important",
            xs: "9px 0 !important"
          }
        },

        minHeight: "auto !important",
        height: "auto !important"
      },
      addOnDiv: {
        paddingTop: "8px",
        paddingBottom: "8px",
        backgroundColor: isChannelLineUpPage ? "#FFFF" : "#21528C",
        [DtvTheme.breakpoints.between(
          DtvTheme.breakpoints.values.sm,
          DtvTheme.breakpoints.values.md
        )]: {

        },
        [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
          paddingBottom: "0px"
        }
      },
      promoDiv: {
        paddingTop: "8px",
        paddingBottom: "8px",
        backgroundColor: isChannelLineUpPage ? "#FFFF" : "#21528C"
      },
      addOnPromoTextDiv: {
        paddingLeft: "15px",
        [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
          paddingLeft: "12.5px"
        }
      },
      maxWidth: { maxWidth: "100% !important" },
      addOnPkgName: {
        background: "#ffffff",
        paddingBottom: "8px",
        paddingTop: "8px",
        marginBottom: "8px"
      },
      infoSec: {
        display: "flex",
        [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.md)]: {
          // display: "block",
          display: "flex !important",
          flexDirection: "column !important"
        }
      },
      channelRow: {
        backgroundColor: colorPalette.neutral_white.main,
        alignItems: "stretch",
        display: "flex",
        flex: "0 1 auto",
        height: "100%",
        width: "100%",
        zIndex: 0
      },
      accSummaryColor: {
        backgroundColor: isChannelLineUpPage ? "#FFFF" : "#21528C",
        color: isChannelLineUpPage ? "jet.main" : "#ffffff",
        height: "35px",
        minHeight: "0px !important",
        "& .DtvAccordionSummary-content": {
          margin: "0px !important"
        },
        "&.Mui-focusVisible": {
          backgroundColor: "#7A7A7A",
          "& p": {
            textDecoration: "underline"
          }
        },
        [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
          height: "26px"
        }
      },
      highlightRowBgColor: {
        backgroundColor: "#DADADA"
      },
      borderRow: {
        borderBottom: isChannelLineUpPage ?
          "1px solid #D1D1D1" :
          "1px solid #555555"
      },
      borderHighlight: {
        border: `1px solid ${isChannelLineUpPage ? "#D1D1D1" : "#999999"}`
      },
      borderHighlightAcc: {
        borderLeft: `1px solid ${isChannelLineUpPage ? "#D1D1D1" : "#999999"}`,
        borderRight: `1px solid ${isChannelLineUpPage ? "#D1D1D1" : "#999999"}`
      },
      borderCol: {
        borderLeft: `${isChannelLineUpPage ? 1 : 2}px solid ${
          isChannelLineUpPage ? "#D1D1D1" : "#999999"
        }`
      },
      mb: {
        marginBottom: "0px"
      },
      marginRow: {
        marginBottom: "0px",
        marginLeft: "0px"
      },
      marginRowNoBottom: {
        marginLeft: "0px",
        marginBottom: "0px"
      },
      tablerowContainer: {
        margin: "0px !important",
        paddingTop: "0px !important"
      },
      tableColPad: {
        maxWidth: `${maxWidth}% !important`,
        paddingBottom: "0px !important",
        paddingLeft: "0px !important",
        [DtvTheme.breakpoints.between(
          DtvTheme.breakpoints.values.sm,
          DtvTheme.breakpoints.values.md
        )]: {
          paddingBottom: "0px !important"
        }
      },
      tableColPadNew: {
        maxWidth: `${maxWidth}% !important`,
        paddingBottom: "0px !important",
        [DtvTheme.breakpoints.between(
          DtvTheme.breakpoints.values.sm,
          DtvTheme.breakpoints.values.md
        )]: {
          paddingBottom: "0px !important"
        },
        [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
          padding: "0px 0px 4px 0px !important"
        }
      },
      singlePkgMaxWidth: {
        [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
          maxWidth: props?.packages.length === 1 ? "100% !important" : ""
        }
      },
      tableLastCol: {
        // paddingRight:"0px !important",
        [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
          padding: "0px 0px 4px 0px !important",
          paddingRight: isChannelLineUpPage ? "16px" : "0px !important"
        }
      },
      borderColorOrangeTop: {
        borderTop: "8px solid rgb(232, 133, 52)",
        borderLeft: "1px solid rgba(232, 133, 52, .5)",
        borderRight: "1px solid rgba(232, 133, 52, .5)",
        paddingTop: "0px !important",
        paddingRight: "0px !important"
      },
      borderColorOrangeSelected: {
        borderLeft: "1px solid rgba(232, 133, 52, .5)",
        borderRight: "1px solid rgba(232, 133, 52, .5)",
        paddingRight: "0px !important"
      },
      borderColorLightBlueTop: {
        borderTop: "8px solid rgb(118, 212, 248)",
        borderLeft: "1px solid rgba(118, 212, 248, .5)",
        borderRight: "1px solid rgba(118, 212, 248, .5)",
        paddingTop: "0px !important",
        paddingRight: "0px !important"
      },
      borderColorLightBlueSelected: {
        borderLeft: "1px solid rgba(118, 212, 248, .5)",
        borderRight: "1px solid rgba(118, 212, 248, .5)",
        paddingRight: "0px !important"
      },
      borderColorBlueTop: {
        borderTop: "8px solid rgb(33, 82, 140)",
        borderLeft: "1px solid rgba(33, 82, 140, .5)",
        borderRight: "1px solid rgba(33, 82, 140, .5)",
        paddingTop: "0px !important",
        paddingRight: "0px !important"
      },
      borderColorBlueSelected: {
        borderLeft: "1px solid rgba(33, 82, 140, .5)",
        borderRight: "1px solid rgba(33, 82, 140, .5)",
        paddingRight: "0px !important"
      },
      borderColorPurpleTop: {
        borderTop: "8px solid rgb(122, 38, 123)",
        borderLeft: "1px solid rgba(122, 38, 123, .5)",
        borderRight: "1px solid rgba(122, 38, 123, .5)",
        paddingTop: "0px !important",
        paddingRight: "0px !important"
      },
      borderColorPurpleSelected: {
        borderLeft: "1px solid rgba(122, 38, 123, .5)",
        borderRight: "1px solid rgba(122, 38, 123, .5)",
        paddingRight: "0px !important"
      },
      borderColorGreyTop: {
        borderTop: "8px solid rgb(151, 151, 151)",
        borderLeft: "1px solid rgba(151, 151, 151, .5)",
        borderRight: "1px solid rgba(151, 151, 151, .5)",
        paddingTop: "0px !important",
        paddingRight: "0px !important"
      },
      borderColorGreySelected: {
        borderLeft: "1px solid rgba(151, 151, 151, .5)",
        borderRight: "1px solid rgba(151, 151, 151, .5)",
        paddingRight: "0px !important"
      },
      headerTopColorLightBlueSelected: {
        borderTop: "12px solid #2E70BD",
        borderRadius: "8px 8px 0px 0px"
      },
      headerTopColorOrangeSelected: {
        borderTop: "12px solid #E88530",
        borderRadius: "8px 8px 0px 0px"
      },
      headerTopColorBlueSelected: {
        borderTop: "12px solid #569CEF",
        borderRadius: "8px 8px 0px 0px"
      },
      headerTopColorPurpleSelected: {
        borderTop: "12px solid #DC55E0",
        borderRadius: "8px 8px 0px 0px"
      },
      headerBold: {
        fontWeight: 500
      },
      paper: {
        color: "#666666",
        textAlign: "center"
      },

      tableBodyRowHeight: {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        [DtvTheme.breakpoints.up(DtvTheme.breakpoints.values.md)]: {
          minHeight: "175px",
          maxHeight: "200px"
        },
        [DtvTheme.breakpoints.between(
          DtvTheme.breakpoints.values.sm,
          DtvTheme.breakpoints.values.md
        )]: {
          minHeight: "212px",
          maxHeight: "255px"
        },
        [DtvTheme.breakpoints.up(DtvTheme.breakpoints.values.xs)]: {
          minHeight: "251px",
          maxHeight: "255px"
        }
      },
      icons: {
        display: "inline-flex",
        verticalAlign: "middle",
        height: "64px", // "58px",
        width: "64px", // "58px",
        // WAT-11362: contain so landscape OV logos aren't cropped (no-op for square logoUrl).
        objectFit: "contain"
      },
      icons1: {
        display: "inline-flex",
        verticalAlign: "middle",
        height: "32px",
        width: "32px",
        [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.md)]: {
          height: "25px",
          width: "25px"
        }
      },
      textAlign: {
        height: isChannelLineUpPage && "100%",
        borderTopLeftRadius: isChannelLineUpPage && "5px",
        borderTopRightRadius: isChannelLineUpPage && "5px",
        ...(viewportWidth <= TABLET_WIDTH && {
          [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.md)]: {
            textAlign: "unset"
          }
        })
      },
      headerName: {
        color: "#666666",
        fontFamily: "roboto-medium",
        fontSize: "18px",
        fontWeight: 400,
        ...(viewportWidth <= TABLET_WIDTH && {
          [DtvTheme.breakpoints.between(
            DtvTheme.breakpoints.values.sm,
            DtvTheme.breakpoints.values.md
          )]: {
            justifyContent: "center",
            marginTop: "0px",
            paddingBottom: "0px"
          },
          [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
            justifyContent: "center",
            marginTop: "0px",
            paddingBottom: "0px"
          }
        })
      },
      imgCls1: {
        ...(viewportWidth <= TABLET_WIDTH && {
          [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.md)]: {
            marginTop: "0px"
          }
        })
      },
      typography: {
        fontFamily: "roboto-regular", // 'PFDinMed', //'dtv-font',
        fontSize: "16px",
        fontWeight: 400,
        width: "99.65%"
      },
      accordionRow: {
        width: "100%"
      }
    };
    const packageCategorySelected = props?.packageCategorySelected ?
      props?.packageCategorySelected.toUpperCase() :
      "";
    const cmprPkg = props?.cmprPkg && props?.cmprPkg.toUpperCase();
    let _modalWithNOCTA;
    if (
      props?.modalView &&
      (modalSrc === "UF" ||
        modalSrc === "SALES" ||
        modalSrc === "INTERNET" ||
        modalSrc === "SATELLITE" ||
        modalSrc === "SUPPORT-INTERNET" ||
        modalSrc === "SUPPORT-SATELLITE" ||
        modalSrc === "SERVICES-INTERNET" ||
        modalSrc === "SERVICES-SATELLITE")
    ) {
      _modalWithNOCTA = false;
    } else {
      _modalWithNOCTA = true;
    }
    const packageColorMap = {
      ENTERTAINMENT: "LightBlue",
      CHOICE: "Orange",
      ULTIMATE: "Blue",
      PREMIER: "Purple",
      MASLATINO: "Grey",
      OPTIMOMAS: "Grey",
      MASULTRA: "Grey",
      LOMAXIMO: "Grey"
    };
    let _borderTopClass = null;
    let _borderSelectedClass = null;
    let cmprPkgIndex = null;
    let _headerTopClass = null;
    if (props?.cmprPkg) {
      props?.packages.forEach((pkg, index) => {
        // //edspPackages
        if (pkg.billingCodeLabel.toUpperCase() === cmprPkg) {
          cmprPkgIndex = index;
          _borderTopClass = `borderColor${packageColorMap[cmprPkg]}Top`;
          _borderSelectedClass = `borderColor${packageColorMap[cmprPkg]}Selected`;
          _headerTopClass = `headerTopColor${packageColorMap[cmprPkg]}Selected`;
        }
      });
    }
    const _handleClick = (event, index) => {
      if (event?.target?.id !== "") {
        if (!expandAccordion[index].expanded) {
          setLatestAccordionOpen([index]);
        }
        expandAccordion[index].expanded = !expandAccordion[index].expanded;
        setExpandAccordion([...expandAccordion]);
        !expandAccordion[index].expanded &&
          index === updatedChnlCategories.length - 1 &&
          window &&
          window.scrollTo(0, 500);
      }
    };
    const _handleChnlNameNumberClick = (event, index) => {
      if (event?.target?.id !== "") {
        if (!chnlNameNumberAccordion[index].expanded) {
          setLatestAccordionOpen([index]);
        }
        chnlNameNumberAccordion[index].expanded =
          !chnlNameNumberAccordion[index].expanded;
        setChnlNameNumberAccordion([...chnlNameNumberAccordion]);
        !chnlNameNumberAccordion[index].expanded &&
          index === chnlNameNumberCategories.length - 1 &&
          window &&
          window.scrollTo(0, 500);
      }
    };

    const [defaultSortOption, _setDefaultSortOption] = useState(true);
    const _primaryDtvRadioButton = {
      label: "Label",
      analytics: {
        tag: "Radiobutton",
        event: "Checked",
        event_name: "Radiobutton"
      },
      mode: "dark" as any,
      variant: "Radio Label" as any,
      ariaLabel: "Sort by",
      radiobuttonoptions:
        props?.sortOptions &&
        props?.sortOptions.map(op => ({
          label: op.value,
          value: op.key,
          ariaLabel: op.value === "A-Z" ? "Sort A to Z" : `Sort by ${op.value}`,
          checked: defaultSortOption ?
            op.value === "A-Z" :
            op.value === "Category"
        }))
    };

    const _bgColors = props?.packageBgColor ?
      props?.packageBgColor :
      {
        entertainment: "#D8E7F9",
        "choice™": "#FEF7EF",
        ultimate: "#ECF3FB",
        "premier™": "#FCF2FD",
        "óptimo más™": "#E0F2FA"
      };
    const _bgColor = "";
    const _pkgColors = {
      entertainment: "#102641",
      choice: "#102641",
      ultimate: "#102641",
      premier: "#102641",
      "ÓPTIMO MÁS™": "#102641"
    };
    const _pkgColor = "";
    const _commonCategory = {};
    const _commonCategoryChannelsArray = [];
    const _displayCommonCategory = false;
    const getTooltipContent = (text?: any, pkgName?: any) => {
      try {
        return (
          <DtvBox sx={{ textAlign: "center" }}>
            <DtvBox sx={{ fontSize: "16px !important" }}>{text}</DtvBox>
            <DtvBox sx={{ fontSize: "16px !important" }}>{pkgName}</DtvBox>
          </DtvBox>
        );
      } catch (error) {
        return <ErrorDisplay error={error} />;
      }
    };
    return (
      <Table
        aria-label="Channel Lineup FFP Table"
        data-testid="table"
        id="table"
        ref={tableRef}
      >
        <TableHead id="tableHeader" ref={tableHeaderRef}  sx={didScroll ? stickyHeaderCss : {}}>
          <DtvGrid
            component={TableRow}
            container={true}
            item={true}
            xs={12}
            sx={{
              ...styles.tablerowContainer,
              ...styles.maxWidth,
              ...styles.tableBorder,
              display: "table",
              gap: "3px"
            }}
            id="tableHeaderRow"
            // style={didScroll ? stickyHeaderCss : {}}
          >
            <DtvGrid
              alignItems="center"
              component={TableCell}
              id="tableCell"
              item={true}
              justifyContent="center"
              key="header"
              md={3}
              sm={3}
              xs={3}
              sx={{
                ...styles.tableColPad,
                maxWidth: `calc(${maxWidth}% - 3px)!important`,
                // borderRight: "2px solid white",
                ...styles.bgColorForChnlsLabel,
                width: "25%"
              }}
            >
              <Paper
                elevation={0}
                id="paper"
                square={true}
                sx={{
                  ...styles.paper,
                  marginBottom: "12px",
                  backgroundColor: "#F4F4F4"
                }}
              >
                <DtvGrid
                  alignItems="center"
                  container={true}
                  justifyContent="center"
                  sx={{
                    ...styles.headerName,
                    backgroundColor: "#F4F4F4"
                  }}
                >
                  <DtvGrid
                    id="chnls"
                    item={true}
                    sx={{ ...styles.imgCls1 }}
                    xs={12}
                  >
                      <Typography id="p-tag-CHANNNELS"
                        style={{
                          marginTop: "10px",
                          color: "black",
                          padding: "15px"
}}
                        sx={{
                          ...(viewportWidth <= TABLET_WIDTH && {
                            [DtvTheme.breakpoints.between(
                              DtvTheme.breakpoints.values.sm,
                              DtvTheme.breakpoints.values.md
                            )]: {
                              top: "132px",
                              transformOrigin: "center",
                              transform: " rotate(270deg) translate(2%, -12px)",
                              writingMode: "revert ",
                              fontSize: "18px ",
                              ...(displayCTA && {
                                top: "132px"
                              })
                            },
                            [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
                              top: "132px",
                              transformOrigin: "center",
                              transform: " rotate(270deg) translate(-2%, -12px)",
                              writingMode: "revert",
                              fontSize: "18px ",
                              ...(displayCTA && {
                                top: "132px"
                              })
                            }
                          })
}}>
                      {"CHANNELS"}
                      </Typography>
                  </DtvGrid>
                </DtvGrid>
              </Paper>
            </DtvGrid>
            <DtvGrid
                      alignItems="center"
                      component={TableCell}
                      item={true}
                      justifyContent="center"
                      md={9}
                      sm={9}
                      xs={9}

                      style={{
                        backgroundColor: "#F4F4F4"
                      }}
                      sx={{
                        padding: "0px"

                      }}
                    >
                      <Paper
                        elevation={0}
                        id={"package-header"}
                        square={true}
                        style={{ backgroundColor: "#f4f4f4" }}
                        sx={{
                          position: "relative",
                          marginTop: cmprPkgIndex !== null ? "12px" : "0px !important",
                          marginBottom: "12px",
                          backgroundColor: "#F4F4F4",
                          ...(viewportWidth <= TABLET_WIDTH && {
                          [DtvTheme.breakpoints.between(
                            DtvTheme.breakpoints.values.sm,
                            DtvTheme.breakpoints.values.md
                          )]: {
                            height: displayCTA ?  "192px" :  "152px"
                          },
                          [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
                            height: displayCTA ?  "192px" : "152px"
                          }
                          })

                        }}
                      >
                        <DtvGrid
                          container={true}
                          sx={{
                            borderBottom: "0px !important",
                            backgroundColor: "#F4F4F4",
                            padding: "15px",
                            ...(!props?.modalView || displayCTA ?
                              {
                                  ...styles.headerName
                                } :
                              {
                                  ...styles.headerName,
                                  ...{ border: isChannelLineUpPage && "none" }
                                })
                          }}
                        >
                          <DtvGrid
                            className="package-name"
                            item={true}
                            style={{ color: "black" }}
                            xs={12}
                            sx={{
                              fontSize: "20px",
                              fontWeight: 500,
                              textAlign: "center",
                              ...(viewportWidth <= TABLET_WIDTH && {
                              [DtvTheme.breakpoints.between(
                                DtvTheme.breakpoints.values.sm,
                                DtvTheme.breakpoints.values.md
                              )]: {
                                top: "132px",
                                position: "absolute ",
                                transformOrigin: "center",
                                transform: " rotate(270deg) translate(50%, -12px)",
                                writingMode: "revert ",
                                fontSize: "18px ",
                                ...(displayCTA && {
                                  top: "132px"
                                })
                              },
                              [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
                                top: "132px",
                                position: "absolute !important",
                                transformOrigin: "center",
                                transform: " rotate(270deg) translate(50%, -12px)",
                                writingMode: "revert",
                                fontSize: "18px ",
                                ...(displayCTA && {
                                  top: "132px"
                                })
                              }
                            })
                            }}

                          >
{myFreeDtvChnls?.myFreeDtvLabel}                        </DtvGrid>
                          <DtvGrid
                            item={true}
                            xs={12}
                            sx={
                             {
                              whiteSpace: "nowrap",
                              fontSize: "14px",
                              textAlign: "center",
                              ...(viewportWidth <= TABLET_WIDTH && {
                                [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.md)]: {
                                  top: "132px",
                                  position: "absolute",
                                  transformOrigin: "center",
                                  transform: " rotate(270deg) translate(50%, 12px) ",
                                  writingMode: "revert ",
                                  ...(displayCTA && {
                                    top: "132px",
                                    transform: " rotate(270deg) translate(50%, 12px)"

                                  })
                                }
                             })
                             }
                            }
                          >
                            {myFreeDtvChnls?.chnlCount}
                          </DtvGrid>
                        </DtvGrid>
                      </Paper>
                    </DtvGrid>

          </DtvGrid>
        </TableHead>
        <TableBody id="tableBody">
                              <Table id="nestedTable">
                                <TableBody
                                  id="nestedTableBody"
                                  style={{ backgroundColor: "#ffffff" }}
                                >
                                  {
                                    categoryChannels.map(
                                      (channel, channelIndex) => {
                                        if(channel?.isMyFreeDTV) {
                                        const _packageIndicators =
                                          (channel &&
                                            channel.packageIndicators &&
                                            channel.packageIndicators[
                                              `${
                                                props?.edspFlow ? "edsp" : "2yr"
                                              }`
                                            ][packageCategorySelected]) ||
                                          [];
                                        const channelsQP = props?.channelsQP ?
                                          props?.channelsQP?.toLowerCase() :
                                          "";
                                        const rowStyles =
                                          channelsQP === "" ?
                                            styles.borderHighlightAcc :
                                            {};
                                        const showChannel = true;

                                        const accordionChannelRowElement = (
                                          <>
                                            <DtvGrid
                                              component={TableRow}
                                              container={true}
                                              id={`row-${channel.chnlNum}-${channelIndex}`}
                                              item={true}
                                              key={channelIndex}
                                              xs={12}
                                              sx={{
                                                backgroundColor:
                                                  isChannelLineUpPage ?
                                                    "#102641" :
                                                    colorPalette.neutral_white.main,
                                                ...styles.tableBorder,
                                                ...styles.accordionRow,
                                                ...(channelIndex ===
                                                categoryChannels.length - 1 ?
                                                  {
                                                      ...styles.marginRow,
                                                      ...rowStyles,
                                                      ...styles.mb
                                                    } :
                                                  {
                                                      ...styles.marginRow,
                                                      ...rowStyles
                                                    })
                                              }}
                                            >
                                              <DtvGrid
                                                alignItems="center"
                                                component={TableCell}
                                                id="tableCell"
                                                item={true}
                                                justifyContent="flex-start"
                                                key={`logo${channelIndex}`}
                                                md={3}
                                                xs={3}
                                                style={{
                                                  borderBottom: "1px solid #D1D1D1"
                                                }}
                                                sx={{
                                                  ...styles.tableColPad,
                                                  ...styles.paper,
                                                  // ...styles.tableBodyRowHeight,
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  justifyContent: "flex-start",
                                                  alignItems: "center",
                                                  position: "relative",
                                                  maxWidth: "25% !important"
                                                  /* [DtvTheme.breakpoints.down(
                                                    DtvTheme.breakpoints.values
                                                      .sm
                                                  )]: {
                                                    minWidth:
                                                      isChannelLineUpPage && {
                                                        xs: "32% !important",
                                                      },
                                                  },*/
                                                }}
                                              >
                                                <Tooltip
                                                  enterTouchDelay={0}
                                                  placement="top"
                                                  PopperProps={{
                                                    sx: {
                                                      marginBottom:
                                                        "-6px !important",
                                                      width: "auto !important",
                                                      fontSize:
                                                        "16px !important"
                                                    }
                                                  }}
                                                  title={getTooltipContent(
                                                    channel.name
                                                  )}
                                                >
                                                  <DtvBox component="span">
                                                    {channel.icon ? (
                                                      <>
                                                        <ChannelLogoChip
                                                          alt={channel.name}
                                                          component="span"
                                                          display="inline-flex"
                                                          imgSx={styles.icons}
                                                          margin="6px 0"
                                                          size="64px"
                                                          isOvLogo={channel?.isOvLogo}
                                                          src={channel.icon}
                                                          verticalAlign="middle"
                                                        />
                                                        <DtvText
                                                          content={channel.name}
                                                          sx={{
                                                            ...styles.channelName,
                                                            display: {
                                                              xs: "none",
                                                              sm: "block"
                                                            }
                                                          }}
                                                          variant={
                                                            isChannelLineUpPage ?
                                                              "body2" :
                                                              "smalltextmedium"
                                                          }
                                                        />
                                                        <DtvText
                                                          content={String(
                                                            channel.chnlNum
                                                          )}
                                                          sx={{
                                                            ...styles.channelName,
                                                            display: "block"
                                                          }}
                                                          variant={
                                                            isChannelLineUpPage ?
                                                              "body2" :
                                                              "smalltextmedium"
                                                          }
                                                        />
                                                      </>
                                                    ) : (
                                                      <>
                                                        <CardMedia
                                                          alt={channel.name}
                                                          component="img"
                                                          src={`https://www.directv.com/dtvassets/global/channel-icons/m-n/Channel_Icon_No-Logo.svg`}
                                                          sx={styles.icons}
                                                        />
                                                        <DtvText
                                                          content={channel.name}
                                                          variant="smalltextmedium"
                                                          sx={{
                                                            ...styles.channelName,
                                                            display: {
                                                              xs: "none",
                                                              sm: "block"
                                                            }
                                                          }}
                                                        />
                                                        <DtvText
                                                          variant="smalltextmedium"
                                                          content={
                                                            channel.chnlNum
                                                          }
                                                          sx={{
                                                            ...styles.channelName,
                                                            display: "block"
                                                          }}
                                                        />
                                                      </>
                                                    )}
                                                  </DtvBox>
                                                </Tooltip>
                                              </DtvGrid>
                                              <DtvGrid
                                                      alignItems="center"
                                                      component={TableCell}
                                                      id="tableCell"
                                                      item={true}
                                                      justifyContent="center"
                                                      key={channelIndex}
                                                      md={9}
                                                      xs={9}
                                                      style={{
                                                        borderBottom: "1px solid #D1D1D1",
                                                        borderLeft: "1px solid #D1D1D1"
                                                      }}
                                                      sx={{
                                                        ...styles.paper,
                                                        // ...styles.tableBodyRowHeight,
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center"
                                                        /* [DtvTheme.breakpoints.down(
                                                          DtvTheme.breakpoints
                                                            .values.sm
                                                        )]: {
                                                          maxWidth:
                                                            isChannelLineUpPage && {
                                                              xs: "17% !important",
                                                            }
                                                        },*/
                                                      }}
                                                    >
                                                    <Tooltip
                                                      enterTouchDelay={0}
                                                      placement="top"
                                                      title={myFreeDtvChnls?.includedLabel}
                                                      PopperProps={{
                                                        sx: {
                                                          marginBottom: '-6px !important',
                                                          width: "auto !important",
                                                          fontSize: "16px !important"
                                                        }
                                                      }}
                                                    >
                                                            <DtvBox component="span">
                                                              <CardMedia
                                                                component="img"
                                                                alt={
                                                                  myFreeDtvChnls?.includedLabel
                                                                }
                                                                src={
                                                                  "https://www.directv.com/dtvassets/global/icons/component-controls/icons-in-table_check.svg"
                                                                }
                                                                sx={{
                                                                  ...styles.icons12
                                                                }}
                                                              />
                                                            </DtvBox>
                                                          </Tooltip>
                                                    </DtvGrid>
                                            </DtvGrid>
                                          </>
                                        );

                                        if (showChannel) {
                                          if (channelIndex <= 15) {
                                            return (
                                              <>{accordionChannelRowElement}</>
                                            );
                                          }
                                            return (
                                              <LazyLoad
                                                height={"60px"}
                                                key={channelIndex}
                                                offset={500}
                                                once={true}
                                              >
                                                {accordionChannelRowElement}
                                              </LazyLoad>
                                            );
                                        }
                                      }
                                      return null;
                                    }
                                    )}
                                </TableBody>
                              </Table>
        </TableBody>
      </Table>
    );
  } catch (error) {
    return <ErrorDisplay component="National Channel Table" error={error} />;
  }
}
